/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import VueSession from 'vue-session'
Vue.use(VueSession)
Vue.use(Router)

const router = new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [

    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: '',
      component: () => import('./layouts/main/Main.vue'),
      redirect: '/login',
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: '/Overview',
          name: 'Overview',
          component: () => import('./views/Overview.vue'),
          meta: {
            pageTitle: 'Overview',
            moduleId: 1,
          }
        },
        {
          path: '/patientDetailsDashboard',
          name: 'PatientDashboard',
          component: () => import('./views/PatientDashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Patient Dashboard', url: '/', active: true }
            ],
            pageTitle: 'Patient Dashboard',
            moduleId: 2,
          },
        },
        {
          path: '/tokenBookingDashboardView',
          name: 'TokenBookingDashboard',
          component: () => import('./views/TokenBookingDashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Token Dashboard', url: '/', active: true }
            ],
            pageTitle: 'Token Dashboard',
            moduleId: 7,
          },
        },
        {
          path: '/tokenBookingDashboard',
          name: 'TokenBookingDashboard',
          component: () => import('./views/QuickopTokenDashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Token Dashboard', url: '/', active: true }
            ],
            pageTitle: 'Token Dashboard',
            moduleId: 7,
          },
        },

        {
          path: '/OpDashboardView',
          name: 'OP',
          component: () => import('./views/OpDashboardView.vue'),
          meta: {
            breadcrumb: [
              { title: 'OP', url: '/', active: true }
            ],
            pageTitle: 'OP Dashboard',
            moduleId: 3,
          },
        },
        {
          path: '/QuickOpDashboard',
          name: 'OP',
          component: () => import('./views/QuickOpDashboardView.vue'),
          meta: {
            breadcrumb: [
              { title: 'OP', url: '/', active: true }
            ],
            pageTitle: 'Quick Op',
            moduleId: 3,
          },
        },
        {
          path: '/IpDashboardView',
          name: 'IP',
          component: () => import('./views/IpDashboardView.vue'),
          meta: {
            breadcrumb: [
              { title: 'IP', url: '/', active: true }
            ],
            pageTitle: 'IP Dashboard',
            moduleId: 4,
          },
        },

        {
          path: '/doctorAppointmentConfig',
          name: 'AppointmentConfig',
          component: () => import('./views/AppointmentConfig.vue'),
          meta: {
            pageTitle: 'Appointment Config',
            moduleId: 8,
          }
        },
        {
          path: '/doctorAppointmentSchedule',
          name: 'AppointmentSchedule',
          component: () => import('./views/AppointmentSchedule.vue'),
          meta: {
            pageTitle: 'Appointment Schedule',
            moduleId: 9,
          }
        },
        {
          path: '/changepassword',
          name: 'ChangePassword',
          component: () => import('./views/ChangePassword.vue'),
          meta: {
            pageTitle: 'Change Password',
          }
        },
        {
          path: '/billMaster',
          name: 'BillMaster',
          component: () => import('./views/BillMaster.vue'),
          meta: {
            pageTitle: 'Bill Master',
            moduleId: 12,
            button: '<vs-button size="small" color="success" type="filled" @click="popupActivo=true" style="margin-left:85%;">New</vs-button>'

          }
        },
        {
          path: '/Master',
          name: 'Master',
          component: () => import('./views/Master.vue'),
          meta: {
            pageTitle: 'Master',
            moduleId: 12,
          }
        },
        {
          path: '/doctorMaster',
          name: 'DoctorMaster',
          component: () => import('./views/DoctorMaster.vue'),
          meta: {
            pageTitle: 'Doctor Master',
            moduleId: 12,
          }
        },
        {
          path: '/roomCategory',
          name: 'RoomCategory',
          component: () => import('./views/RoomCategory.vue'),
          meta: {
            pageTitle: 'Room Category',
            moduleId: 12,
          }
        },
        {
          path: '/roomMaster',
          name: 'RoomMaster',
          component: () => import('./views/RoomMaster.vue'),
          meta: {
            pageTitle: 'Room Master',
            moduleId: 12,
          }
        },
        {
          path: '/roomRateEntry',
          name: 'RoomRateEntry',
          component: () => import('./views/RoomRateEntry.vue'),
          meta: {
            pageTitle: 'Room Rate Entry'
          }
        },
        {
      path: '/userMaster',
      name: 'UserMaster',
      component: () => import('./views/UserMaster.vue'),
      meta: {
            pageTitle: 'User Master',
            moduleId: 12,
          }
    },
        {
          path: '/billReports',
          name: 'BillReports',
          component: () => import('./views/BillReports.vue'),
          meta: {
            pageTitle: 'Bill Reports'
          }
        },
         {
          path: '/OpReports',
          name: 'OpReports',
          component: () => import('./views/OpReports.vue'),
          meta: {
            pageTitle: 'OP Reports'
          }
        },
        ,
       
        {
          path: '/tokenReports',
          name: 'TokenReports',
          component: () => import('./views/TokenReports.vue'),
          meta: {
            pageTitle: 'Token Reports'
          }
        },
        {
          path: '/TokenShiftReport',
          name: 'TokenShiftReports',
          component: () => import('./views/TokenShiftReport.vue'),
          meta: {
            pageTitle: 'Token Shift Reports'
          }
        },
        {
          path: '/patientRegistration',
          name: 'PatientRegistration',
          component: () => import('./views/PatientRegistration.vue'),
          props: true,
          meta: {
            pageTitle: 'Patient Registration',
            moduleId: 2,
          }
        },
        {
          path: '/tokendirectEntry',
          name: 'TokendirectEntry',
          component: () => import('./views/TokendirectEntry.vue'),
          meta: {
            pageTitle: 'Token Direct Booking',
            moduleId: 7,
          }
        },
        {
          path: '/patientTray',
          name: 'PatientTray',
          component: () => import('./views/PatientTray.vue'),
          meta: {
            pageTitle: 'Patient Tray',
            moduleId: 2,
          }
        },
        {
          path: '/billingDashboard',
          name: 'BillingDashboard',
          component: () => import('./views/BillingDashboard.vue'),
          meta: {
            breadcrumb: [
              { title: 'Billing', url: '/', active: true }
            ],
            pageTitle: 'Billing Dashboard',
            moduleId: 5,
          }
        },
        {
          path: '/paymentCollection',
          name: 'PaymentCollection',
          component: () => import('./views/receiptDashboard.vue'),
          meta: {
            pageTitle: 'Receipt',
            breadcrumb: [
              { title: 'Receipt', url: '/', active: true }
            ],
            moduleId: 6,
          }
        }



      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: '',
      component: () => import('@/layouts/full-page/FullPage.vue'),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: '/admin',
          name: 'admin',
          component: () => import('@/views/admin/pages/Login.vue')
        },
        {
          path: '/login',
          name: 'pageLogin',
          component: () => import('@/views/pages/Login.vue')
        },
        {
          path: '/forgotPassword',
          name: 'ForgotPassword',
          component: () => import('@/views/pages/ForgotPassword.vue')
        },
        {
          path: '/register',
          name: 'pageRegister',
          component: () => import('@/views/pages/Register.vue')
        },
        {
          path: '/pages/error-404',
          name: 'pageError404',
          component: () => import('@/views/pages/Error404.vue')
        },
        {
          path: '/billing',
          name: 'Billing',
          component: () => import('./views/Billing.vue')
        },
        {
          path: '/opTicket',
          name: 'OpTicket',
          component: () => import('./views/OpTicket.vue')
        },
        {
          path: '/discharge',
          name: 'Discharge',
          component: () => import('./views/Discharge.vue'),


        },

        {
          path: '/ipDetails',
          name: 'IP',
          component: () => import('./views/IpDetails.vue')
        },
        {
          path: '/billDues',
          name: 'BillDues',
          component: () => import('./views/BillDues.vue')
        },
        {
          path: '/labResults',
          name: 'LabResult',
          component: () => import('./views/LabResult.vue')
        },
        {
          path: '/prescription',
          name: 'Prescription',
          component: () => import('./views/Prescription.vue')
        },
        {
          path: '/prescriptionDashboard',
          name: 'prescriptionDashboard',
          component: () => import('./views/prescriptionDashboard.vue')
        },
        {
          path: '/roomChangeorVacate',
          name: 'Change or Vacate',
          component: () => import('./views/roomChangeorVacate.vue')
        },
        {
          path: '/QuickOp',
          name: 'QuickOp',
          component: () => import('./views/QuickOp.vue')
        }
      ]
    },
    // Redirect to 404 page, if no match found
    {
      path: '*',
      redirect: '/pages/error-404'
    },
    {
      path: '',
      component: () => import('./layouts/admin/Admin.vue'),
      children: [
        {
          path: '/admin/dashboard',
          name: 'clinicMaster',
          component: () => import('@/views/admin/Dashboard.vue'),
          meta: {
            pageTitle: 'Dashboard'
          }
        },
        {
          path: '/admin/clinicMaster',
          name: 'addClinic',
          component: () => import('@/views/admin/clinicMaster.vue'),
          meta: {
            pageTitle: 'Add Clinic'
          }
        },
        {
          path: '/admin/doctorMaster',
          name: 'addDoctor',
          component: () => import('@/views/admin/doctorMaster.vue'),
          meta: {
            pageTitle: 'Add Doctor'
          },
        },
        {
          path: '/admin/clinicDashboard',
          name: 'Clinics',
          component: () => import('@/views/admin/ClinicDashboard.vue'),
          meta: {
            pageTitle: 'Clinics'
          }
        },
        {
          path: '/admin/doctorDashboard',
          name: 'doctorMaster',
          component: () => import('@/views/admin/DoctorDashboard.vue'),
          meta: {
            pageTitle: 'Doctors'
          }
        }

      ]
    }
  ],
})

router.afterEach(() => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = "none";
  }
});


router.beforeEach((to, from, next) => {

  const modules = store.state.userModules || []

  if (
    router.app.$session.get('companyId') ||
    to.path === '/login' ||
    to.path === '/register' ||
    to.path === '/forgotPassword' ||
    to.path === '/admin'
  ) {

    if (to.meta && to.meta.moduleId) {

      if (modules.length === 0 || modules.includes(to.meta.moduleId)) {
        next()
      } else {
        next('/pages/error-404')
      }

    } else {
      next()
    }

  } else if (router.app.$session.get('adminId')) {

    next()

  } else {

    next('/login')

  }

})
/*router.beforeEach((to, from, next) => {
  if (router.app.$session.get('companyId') || to.path == '/login' || to.path == '/register' || to.path == '/forgotPassword' || to.path == '/admin') {
    next()
  } else if (router.app.$session.get('adminId')) {
    next()
  } else {
    next('/login')
  }

});*/
export default router
